var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group-course-analysis"},[_c('MyBreadcrumb'),_c('div',{staticClass:"group-course-analysis-cont"},[_c('StuAnalysis',{attrs:{"courseId":_vm.courseId,"groupId":_vm.groupId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }